import { ColumnState } from 'ag-grid-community';
import { create } from 'zustand';
import { CompanyDto } from '../dtos/company/companyDto';

export interface CompanyStore {

	companyList: CompanyDto[];
	setCompanyList: (companyList: CompanyDto[]) => void;

	initData: (moneyCd: string, collectTarget: string, paymentTarget: string, exceptionCollect: string, exceptionPayment: string) => void;
}

export const defaultEditCompany: CompanyDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	compCd: '',
	compNm: '',
	compNmFull: '',
	represent: '',
	regNo: '',
	telNo: '',
	faxNo: '',
	taxMobile: '',
	taxEmail: '',
	post: '',
	address: '',
	detailAddress: '',
	businessType: '',
	businessClass: '',
	moneyCd: '',
	collectTarget: '',
	paymentTarget: '',
	exceptionCollect: '',
	exceptionPayment: '',
	labelPrintAuto: '',
	apikey: '',
	remark: '',
	logoImage: '',
	signImage: '',

	inserted: false,
	isModified: false,
}

export const useCompanyStore = create<CompanyStore>((set) => ({

	companyList: [],
	setCompanyList: (companyList: CompanyDto[]) => set((state) => {
		return {
			...state,
			companyList
		}
	}),

	initData: (moneyCd: string, collectTarget: string, paymentTarget: string, exceptionCollect: string, exceptionPayment: string) => set((state) => ({
		...state,
		selectedCompany: undefined,
		editCompany: {
			...defaultEditCompany,
			moneyCd,
			collectTarget,
			paymentTarget,
			exceptionCollect,
			exceptionPayment
		},
		compNm: '',
		companyList: []
	}))
}));